<footer class="footer-admin mt-auto" [ngClass]="{ 'footer-light': !dark, 'footer-dark': dark }">
  <div class="container-fluid px-4">
    <div class="row gx-4">
      <div class="col-md-6 small">Copyright &copy; Plasma Games {{ year }}</div>
      <div class="col-md-3 text-md-end small"><a routerLink="/eula">EULA</a></div>
      <div class="col-md-3 text-md-end small"><a routerLink="/privacy">Privacy Policy</a></div>
    </div>
  </div>
</footer>
